import React from 'react';
const CancellationPolicy = () => {
  return <div className="min-h-screen bg-white" data-id="element-408">
      <div className="bg-mwc-burgundy text-white py-12" data-id="element-409">
        <div className="container mx-auto px-4" data-id="element-410">
          <h1 className="text-3xl font-bold text-center mb-4" data-id="element-411">
            Cancellation Terms
          </h1>
          <p className="text-lg text-center max-w-3xl mx-auto" data-id="element-412">
            Our fair and transparent terms regarding service package and
            appointment cancellations
          </p>
        </div>
      </div>
      <div className="container mx-auto px-4 py-12" data-id="element-413">
        <div className="max-w-3xl mx-auto" data-id="element-414">
          <div className="bg-white rounded-lg shadow-md p-8" data-id="element-415">
            <div className="mb-8" data-id="element-416">
              <p className="text-gray-700" data-id="element-417">
                At Maplewood-Care, we understand that circumstances can change.
                Our cancellation terms are designed to be fair and transparent
                for our prepaid service packages and scheduled appointments.
              </p>
            </div>
            <div className="mb-8" data-id="element-418">
              <h2 className="text-2xl font-bold text-mwc-burgundy mb-4" data-id="element-419">
                Service Package Cancellations
              </h2>
              <div className="space-y-4" data-id="element-420">
                <div className="bg-mwc-lightpink p-4 rounded-lg" data-id="element-421">
                  <h3 className="font-semibold text-mwc-burgundy mb-2" data-id="element-422">
                    Cooling-Off Period (14 Days)
                  </h3>
                  <p className="text-gray-700" data-id="element-423">
                    You may cancel your prepaid service package within 14 days
                    of purchase for a full refund, provided no engineer callouts
                    have been requested. This is your statutory cooling-off
                    period under UK consumer protection law.
                  </p>
                </div>
                <div className="bg-mwc-lightpink p-4 rounded-lg" data-id="element-424">
                  <h3 className="font-semibold text-mwc-burgundy mb-2" data-id="element-425">
                    After the Cooling-Off Period
                  </h3>
                  <p className="text-gray-700" data-id="element-426">
                    After the cooling-off period, you may cancel your prepaid
                    service package at any time by providing 30 days' written
                    notice. For annual packages paid in full, we will refund the
                    remaining months on a pro-rata basis, less a £25
                    administration fee, provided the value of services used does
                    not exceed the refund amount.
                  </p>
                </div>
                <div className="bg-mwc-lightpink p-4 rounded-lg" data-id="element-427">
                  <h3 className="font-semibold text-mwc-burgundy mb-2" data-id="element-428">
                    Monthly Payment Packages
                  </h3>
                  <p className="text-gray-700" data-id="element-429">
                    For monthly payment packages, your service access will
                    continue until the end of the current paid period, and no
                    further payments will be collected after you submit your
                    cancellation request.
                  </p>
                </div>
              </div>
            </div>
            <div className="mb-8" data-id="element-430">
              <h2 className="text-2xl font-bold text-mwc-burgundy mb-4" data-id="element-431">
                Appointment Cancellations
              </h2>
              <div className="space-y-4" data-id="element-432">
                <div className="bg-mwc-lightpink p-4 rounded-lg" data-id="element-433">
                  <h3 className="font-semibold text-mwc-burgundy mb-2" data-id="element-434">
                    Standard Notice Period
                  </h3>
                  <p className="text-gray-700" data-id="element-435">
                    If you need to cancel a scheduled engineer visit, please
                    provide at least 24 hours' notice to avoid any cancellation
                    fees. You can reschedule your appointment at no charge with
                    proper notice.
                  </p>
                </div>
                <div className="bg-mwc-lightpink p-4 rounded-lg" data-id="element-436">
                  <h3 className="font-semibold text-mwc-burgundy mb-2" data-id="element-437">
                    Late Cancellations
                  </h3>
                  <p className="text-gray-700" data-id="element-438">
                    Cancellations made with less than 24 hours' notice may incur
                    a £30 cancellation fee to cover our operational costs and
                    engineer scheduling. Exceptions may be considered for
                    genuine emergencies or circumstances beyond your control.
                  </p>
                </div>
                <div className="bg-mwc-lightpink p-4 rounded-lg" data-id="element-439">
                  <h3 className="font-semibold text-mwc-burgundy mb-2" data-id="element-440">
                    No Access to Property
                  </h3>
                  <p className="text-gray-700" data-id="element-441">
                    If our engineer arrives at your property and cannot gain
                    access due to no one being home or the property being
                    inaccessible, this will be treated as a late cancellation
                    and may incur the standard £30 cancellation fee. Please
                    ensure someone is available during the scheduled appointment
                    window.
                  </p>
                </div>
              </div>
            </div>
            <div data-id="element-442">
              <h2 className="text-2xl font-bold text-mwc-burgundy mb-4" data-id="element-443">
                How to Cancel
              </h2>
              <div className="bg-mwc-lightpink p-4 rounded-lg" data-id="element-444">
                <p className="text-gray-700 mb-4" data-id="element-445">
                  To cancel your service package or a scheduled appointment,
                  please contact our customer service team:
                </p>
                <ul className="list-disc pl-6 text-gray-700" data-id="element-446">
                  <li className="mb-2" data-id="element-447">
                    <span className="font-semibold" data-id="element-448">Phone:</span> 0800 055 4969
                    (Monday to Friday, 9am to 7pm; Saturday, 9am to 2pm)
                  </li>
                  <li data-id="element-449">
                    <span className="font-semibold" data-id="element-450">Email:</span>{' '}
                    support@maplewood-care.com
                  </li>
                </ul>
                <p className="text-gray-700 mt-4" data-id="element-451">
                  Please include your name, address, and service package
                  reference number when making a cancellation request. Written
                  confirmation of your cancellation will be sent to you within 2
                  business days.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>;
};
export default CancellationPolicy;